import { render, staticRenderFns } from "./StudentChangePaymentCardModal.vue?vue&type=template&id=9f1dd03a&"
import script from "./StudentChangePaymentCardModal.vue?vue&type=script&lang=ts&"
export * from "./StudentChangePaymentCardModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports